export const SaveApplicantForm = (fields) => {

  return ({
    type: 'GET_APPLICANT_DATA',
    payload: { ...fields },
  });
};
export const ApplicantFields = (fields) => {
  return ({
    type: 'GET_APPLICANT_VALUES',
    payload: { ...fields },
  });
};

export default { SaveApplicantForm, ApplicantFields };
